import Button from "common/components/Button/Button"
import notification from "common/utils/notification"
import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants/index"
import { useTaxes } from "features/User/pages/Taxes/useTaxes"
import { withFormik } from "formik"
import { useSelector } from "hooks/useSelector"
import { InputNumber } from "primereact/inputnumber"
import { InputText } from "primereact/inputtext"
import { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { globalSelector } from "routes/globalSlice"
import * as Yup from "yup"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { getNewDocumentCurrency } from "../redux/selectors/newDocumentoSettingsSelectors"
import {
  addConcepto,
  recalculate,
  replaceConcepto,
} from "../redux/slices/newDocumentoSlice"
import ImpuestosForm from "./ImpuestosForm"

const DatosFactura = ({
  isValid,
  handleSubmit,
  sinValorar,
  values,
  handleChange,
  onHide,
  setFieldValue,
  isEditModal,
  isLibrado,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const currency = useSelector(getNewDocumentCurrency)
  const refFirstInput = useRef()
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { taxes, getConceptTaxesRetention } = useTaxes()
  const taxesFormatted = taxes.map((impuesto) => ({
    // @ts-expect-error TS(2698): Spread types may only be created from object types...
    ...impuesto,
    // @ts-expect-error TS(2339): Property 'nombre' does not exist on type 'never'.
    label: `${impuesto.nombre}`,
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    value: impuesto.id,
    // @ts-expect-error TS(2339): Property 'valor' does not exist on type 'never'.
    fieldValue: impuesto.valor,
  }))

  useEffect(() => {
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    refFirstInput.current.focus()
    getConceptTaxesRetention(0)
  }, [getConceptTaxesRetention])

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete='off'
      style={{ paddingBottom: "60px" }}
    >
      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='conceptoInput'>
            {t("crear.facturaRec.modal.conceptLabel")}
          </label>

          <InputText
            // @ts-expect-error TS(2769): No overload matches this call.
            ref={refFirstInput}
            id='conceptoInput'
            name='concepto'
            aria-describedby='username-help'
            value={values.concepto}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className='mb-2 p-fluid'>
        <div className='p-field'>
          <label htmlFor='cantidadInput'>
            {t("crear.facturaRec.modal.cantidadLabel")}
          </label>

          <InputNumber
            id='cantidadInput'
            name='cantidad'
            min={0}
            minFractionDigits={2}
            mode='decimal'
            value={values.cantidad}
            onChange={(e) => setFieldValue("cantidad", e.value)}
          />
        </div>
      </div>

      {!sinValorar && (
        <>
          <div className='mb-2 p-fluid'>
            <div className='p-field'>
              <label htmlFor='precioInput'>
                {t("crear.facturaRec.modal.priceLabel")}
              </label>

              <InputNumber
                id='precioInput'
                name='precioVenta'
                min={0}
                minFractionDigits={2}
                mode='currency'
                currency={currency || DEFAULT_CURRENCY_ABREVIATURE}
                value={values.precioVenta}
                onChange={(e) => setFieldValue("precioVenta", e.value)}
              />
            </div>
          </div>
          <div className='p-field d-flex flex-column'>
            <ImpuestosForm
              values={values}
              setFieldValue={setFieldValue}
              dropdownId='impuestoArticuloTipoId'
              inputId='impuestoArticuloPorcentaje'
              title='Tipo de impuesto'
              inpuestosList={taxesFormatted}
              dropdownValue={values.impuestoArticuloTipoId}
              isLibrado={isLibrado}
            />
          </div>
        </>
      )}

      <div className='mt-4 col'>
        <div className='row justify-content-end align-items-center'>
          <a
            role='button'
            href='#'
            className='mr-3 link-cancel'
            onClick={onHide}
          >
            {t("crear.facturaRec.modal.cancelButton")}
          </a>

          <Button
            className='!tw-bg-primary'
            type='submit'
            disabled={!isValid}
          >
            {isEditModal
              ? t("crear.facturaRec.modal.saveButton")
              : t("crear.facturaRec.modal.addButton")}
          </Button>
        </div>
      </div>
    </form>
  )
}

const validate = (props: $TSMigrationFixMe) => {
  const validacionCantidad = Yup.number().min(0.01).required()

  return Yup.object().shape({
    concepto: Yup.string().required(),
    cantidad: validacionCantidad,
    precioVenta: Yup.number().min(0).required(),
    impuestoArticuloPorcentaje: Yup.number()
      .min(0)
      .required()
      .when("impuestoArticuloTipoId", {
        is: false,
        then: Yup.number().required(props.t("errors.specifyValue")),
      }),
  })
}

const CreateWithFormik = withFormik({
  validationSchema: validate,
  validateOnMount: true,
  // @ts-expect-error TS(2339): Property 'concepto' does not exist on type '{}'.
  mapPropsToValues: ({ concepto, taxes, isLibrado, ...props }) => {
    const tipoDocumento = isLibrado ? 0 : 1
    const filteredIVA = taxes.filter(
      ({
        esActivo,
        grupoImpuesto: { tipoGrupoImpuesto },
        tipo,
      }: $TSMigrationFixMe) =>
        tipoGrupoImpuesto === 0 && esActivo && tipo === tipoDocumento
    )
    const tax =
      filteredIVA.find((entry: $TSMigrationFixMe) => entry.valor === 21) ||
      filteredIVA[0]
    // @ts-expect-error TS(2339): Property 'isLibrado' does not exist on type '{}'.
    const userInfo = props.isLibrado ? props.librador : props.librado
    const impuestoRepercutido = userInfo?.impuestoRepercutidoId || 0

    const getImpuestoPorcentaje = () => {
      if (concepto === null && !concepto?.impuestoArticuloPorcentaje) {
        if (impuestoRepercutido && impuestoRepercutido !== 0) {
          return taxes.find(
            ({ id }: $TSMigrationFixMe) => id === impuestoRepercutido
          )?.valor
        }
        return tax?.valor
      }
      return concepto.impuestoArticuloPorcentaje
    }
    const getImpuestoId = () => {
      if (
        (concepto === null && !concepto?.impuestoArticuloTipoId) ||
        (concepto.precioVenta === 0 &&
          concepto?.impuestoArticuloTipoId === undefined) ||
        concepto?.impuestoArticuloTipoId === undefined
      ) {
        if (impuestoRepercutido && impuestoRepercutido !== 0) {
          return impuestoRepercutido
        }
        return tax?.id
      }
      return taxes
        .filter((taxe: $TSMigrationFixMe) => taxe.tipo === (isLibrado ? 0 : 1))
        .find(
          (taxe: $TSMigrationFixMe) =>
            taxe.value === concepto?.impuestoArticuloTipoId
        )?.id
    }

    return {
      id: concepto?.id || "",
      concepto: concepto?.concepto || "",
      cantidad: concepto?.cantidad || 1,
      precioVenta: concepto?.precioVenta || 0,
      impuestoArticuloTipoId: getImpuestoId(),
      impuestoArticuloPorcentaje: getImpuestoPorcentaje(),
    }
  },
  handleSubmit: (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'conceptos' does not exist on type 'objec...
    const conceptoExists = props.conceptos.find(
      (concepto: $TSMigrationFixMe) => {
        // @ts-expect-error TS(2339): Property 'isEditModal' does not exist on type 'obj...
        const condition = !props.isEditModal
          ? values.id !== concepto.id
          : // @ts-expect-error TS(2339): Property 'concepto' does not exist on type 'object...
            values.concepto !== props.concepto.concepto
        return (
          concepto.precioVenta === values.precioVenta &&
          concepto.concepto === values.concepto &&
          condition
        )
      }
    )

    if (conceptoExists) {
      return notification.errorServidor({
        // @ts-expect-error TS(2339): Property 't' does not exist on type 'object'.
        body: `${props.t("errors.alreadyExist")}`,
      })
    }

    // @ts-expect-error TS(2339): Property 'isEditModal' does not exist on type 'obj...
    if (!props.isEditModal) {
      // @ts-expect-error TS(2339): Property 'addConcepto' does not exist on type 'obj...
      props.addConcepto(values)
      // @ts-expect-error TS(2339): Property 'replaceConcepto' does not exist on type ...
    } else props.replaceConcepto({ ...props.concepto, ...values })

    // @ts-expect-error TS(2339): Property 'recalculate' does not exist on type 'obj...
    props.recalculate()

    // @ts-expect-error TS(2339): Property 'onHide' does not exist on type 'object'.
    props.onHide()
  },
})(DatosFactura)

const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => {
  return {
    recalculate: () => dispatch(recalculate()),
    addConcepto: (concepto: $TSMigrationFixMe) => {
      return dispatch(addConcepto(concepto))
    },
    replaceConcepto: (concepto: $TSMigrationFixMe) =>
      dispatch(replaceConcepto(concepto)),
  }
}

const mapStateToProps = (state: $TSMigrationFixMe) => ({
  isEditModal: !!newDocumentoSelector(state).conceptoToEdit,
  concepto: newDocumentoSelector(state).conceptoToEdit,
  conceptos: newDocumentoSelector(state).conceptos,
  tiposImpuestosArticulos: globalSelector(state).tiposImpuestosArticulos,
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateWithFormik)
